// extracted by mini-css-extract-plugin
export default {"svgIcon":"password_svgIcon__9BhE7","icon":"password_icon__7cT2a"};